import {SummaryModel} from '../../../../../common/entity/summary.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {Moment} from 'moment';
import {ConsultationCategorySummaryModel} from '../../../category/api/model/consultationCategorySummary.model';
import {UserSummary} from '../../../../../account/modules/user/api/entity/userSummary.model';
import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {OfficeSummaryModel} from '../../../../../office/api/model/officeSummary.model';


export class ConsultationSummaryModel implements SummaryModel {
    id: number;
    date: Moment;
    status: LovValueSummary;
    category: ConsultationCategorySummaryModel;
    office: OfficeSummaryModel;
    responsible: UserSummary;
    partner: PartnerSummaryModel;
    cancellationType: LovValueSummary;
    cancellationReason: string;
    cancelledUser: UserSummary;
    permissions: PermissionsModel;
    hasNote: boolean;
    eventId: number;
    mode: LovValueSummary;
}

export enum ConsultationStatus {
    PLANNED= 'MEDICAL_CONSULTATION_STATUS_PLANNED',
    EXPECTED = 'MEDICAL_CONSULTATION_STATUS_EXPECTED',
    DONE = 'MEDICAL_CONSULTATION_STATUS_DONE'
}

export enum ConsultationPermission {
    START= 'PERMISSION_MEDICAL_CONSULTATION_START',
    SET_IGNORE_EXPECTED = 'PERMISSION_MEDICAL_CONSULTATION_SET_IGNORE_EXPECTED'
}
